import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    date: String,
    habit: String
  }
  static classes = [ "status" ]
  //connect() {
    //console.log(this.statusClasses)
  //}

  toggle(event) {
    this.statusClasses.forEach(function(item, index) {
      event.target.classList.toggle(item)
    });
  }
}
